import * as React from 'react';
export const IcLotus = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M6.13 7.1c.431-.94.95-1.837 1.55-2.68A12.568 12.568 0 006 4a1 1 0 00-1.07.62A14.5 14.5 0 004.24 7c.631-.002 1.262.031 1.89.1zM19.76 7c-.15-.807-.367-1.6-.65-2.37A1 1 0 0018 4c-.579.098-1.15.235-1.71.41.61.845 1.14 1.745 1.58 2.69a16.887 16.887 0 011.89-.1zm2.18 2.94a1 1 0 00-.88-.88 11.578 11.578 0 00-1.3-.06c-.34 0-.74 0-1.17.05A11.3 11.3 0 0119 12a14 14 0 01-3.54 8.7 8.49 8.49 0 004-2.12c3.1-3.07 2.54-8.42 2.48-8.64zM5.41 9.05C5 9 4.58 9 4.24 9c-.434-.004-.868.016-1.3.06a1 1 0 00-.88.88c0 .22-.62 5.57 2.44 8.64a8.56 8.56 0 004 2.12A14 14 0 015 12a11.3 11.3 0 01.41-2.95zm7.26-5.8A1 1 0 0012 3a1 1 0 00-.67.25C11.15 3.41 7 7.19 7 12c0 4.81 4.15 8.59 4.33 8.75A1 1 0 0012 21a1 1 0 00.67-.25C12.84 20.59 17 16.81 17 12c0-4.81-4.16-8.59-4.33-8.75z'
      fill='currentColor'
    />
  </svg>
);
